export default __webpack_public_path__ + "static/media/writing-options.6ec1bffb.jpg";